module.exports = __webpack_public_path__ + "img/ic_part_quote_price.2d06586a.svg";